import { render, staticRenderFns } from "./ReleaseOrderMainFormEditor.vue?vue&type=template&id=580146e6"
import script from "./ReleaseOrderMainFormEditor.vue?vue&type=script&lang=js"
export * from "./ReleaseOrderMainFormEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports